import styled from "styled-components";

export const StyledButton = styled("button")<any>`
  background: ${(p) => p.color || "#E2C044"};
  color: ${(p) => (p.color ? "#E2C044" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #D3D0CB;
  border-radius: 4px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(59 48 45 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid #6E8898;
    background-color: #6E8898;
  }
`;
